<template>
<div>
  <div class="header other-banner other-banner-news" id="">
    <div class="container">
      <div class="other-banner-title">{{$t('detail.NewsLetters')}}</div>
    </div>
  </div>

  <!--content-->
  <div class="content bgf5f5f5">
    <div>&nbsp;</div>
    <div class="container sub-nav news-nav">
      <div class="col-md-12">
        <router-link to="news" class=" ">{{$t('detail.RecentActivities')}}</router-link>
        <router-link to="newsCompany" class=" cur">{{$t('detail.CompanyNews')}}</router-link>
      </div>
    </div>
    <!--帮助中心-->
    <div class="container col-jj">
      <div class="col-md-12">
        <div class="detail_con">
          <div v-if="news.newsData02" v-for="(item,index) in news.newsData02">
            <p v-if="item.newsCode + '' === $route.query.id" v-html="item.newsSubject "></p>
          </div>
          <div v-else>暂无数据</div>
          <p v-if="news.newsData02&&news.newsData02.find(item=>item.newsCode + '' === $route.query.id)===undefined">{{$t('global.empty')}}</p>
        </div>
      </div>

    </div>
    <!--帮助中心../-->

  </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
        name: "help01",
        computed:{
          ...mapGetters([
            'news'
          ])
        },
        mounted(){
          this.getData()
        },
        methods:{
          getData(){
            this.$store.dispatch('getNewsList',{ language: this.$i18n.locale })
          }
        }

    }
</script>




// WEBPACK FOOTER //
// detail02.vue?3e252deb